export const routes = {
  root: "/dashboard",
  auth: {
    login: {
      root: "/auth/login",
      sendOtp: "/auth/login/send-otp",
      submitOtp: "/auth/login/submit-otp",
    },
    signup: {
      root: "/auth/signup",
      submitOtp: "/auth/signup/submit-otp",
      info: "/auth/signup/info",
    },
  },
};
